<template>
  <div>
    <center> <img :src="imgUrl" style="width: 100%;margin-bottom: -6px;"></center>
    <div class="demo">
      <el-carousel :autoplay="true" type="card" height="540px">
        <el-carousel-item v-for="(val,i) in democardL" :key="i" >
          <center> 
            <DemoCard
              :demoId = "val['demoId']"
              :title  = "val['title']"
              :time  = "val['time']"
              :detail = "val['detail']"
              :imgUrl = "val['imgUrl']"
            /> 
          </center>
        </el-carousel-item>
    </el-carousel>
    </div>
  </div>
</template>

<script>
import DemoCard from "./DemoCard.vue"
export default {
  components: { DemoCard },
  data() {
    return {
      demoL:[
        {
          "title":"滨海新区蓟运河水质采样检测作业",
          "time":"2021年10月22日",
          "imgUrl":"img/demo-01.png",
          "detail":"受滨海新区水务局委托，天津易科芯科技有限公司到蓟运河进行应急水质采样作业"
        },
        {
          "title":"山东庆云庆县云马颊河巡检项目",
          "time":"2021年7月10日",
          "imgUrl":"img/demo-02.png",
          "detail":"受山东省德州市环境保护监测站委托，天津易科芯科技有限公司联合相关单位到庆云庆县云马颊河多地进行水质采样作业"
        },
        {
          "title":"天津市生态城环境局海岸巡检项目",
          "time":"2020年8月15日",
          "imgUrl":"img/demo-03.png",
          "detail":"天津易科芯科技有限公司联合生态城环境局，对生态城海岸主航道进行排污口巡检作业"
        },
        {
          "title":"永定新河北辰段环境应急监测演练",
          "time":"2021年11月12日",
          "imgUrl":"img/demo-04.png",
          "detail":"天津易科芯科技有限公司携带本公司自主研发生产的USW PRO版智能水体采集系统，搭载大疆M600无人机，参加永定新河北辰段环境应急监测演练"
        }
      ],
      democardL:[],
      imgUrl: "",
    };
  },
  created() {
    this.$http.get("api/vue_config/democard_all").then((response) => {
      // console.log(response.data.data)
      this.democardL = JSON.parse(response.data.data)
    });
    this.$http.get("api/vue_config/demo_top_img").then((response) => {
      this.imgUrl = response.data.data
    });

  },

}
</script>

<style lang="less" scoped>

.demo{
  // display: inline-block;
  text-align: center;
  background-color: #fff;
}

</style>
